import { LoanQualificationScreen } from "@/screens/loans/setup/LoanQualificationScreen"
import { convertPreQualToLoanApp } from "@/stores/preQual"
import { router } from "expo-router"
import { useLoanContext } from "@/screens/loans/components/LoanContext"

export default function LoanQualification() {
  const { update, save } = useLoanContext()

  async function onSubmit() {
    update(convertPreQualToLoanApp())
    await save()
    router.push("./property")
  }

  return <LoanQualificationScreen onSubmit={onSubmit} />
}
